//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import search from '~/graphql/queries/search.gql';
import zoektermen from '~/graphql/queries/zoektermen.gql';

export default {
  auth: false,
  apollo: {
    zoektermen: {
      query: zoektermen,
      variables: {
        limit: 5,
      },
    },
    search: {
      query: search,
      throttle: 500,
      variables() {
        return {
          query: this.searchQuery,
          limit_therapeuten: 3,
          limit_nieuws: 4,
        };
      },
    },
  },
  data: () => ({
    zoektermen: [],
    search: {
      therapeuten: [],
      nieuws: [],
    },
    searchQuery: '',
  }),
  head: () => ({
    title: 'Zoeken op de site',
  }),
};
